module.exports = __webpack_public_path__ + "img/2.d0b0d53b.png";